export default __webpack_public_path__ + "static/media/Close.4efee5b7.svg";